import { useState } from "react";
import { LogsMenu } from "../data";
import { TabButtons } from "../detail";
import "./index.css";
export const Logs = () => {
  const [selectedTab, setSelectedTab] = useState("");
  const [market, setMarket] = useState("GER");
  const [script, setScript] = useState("");
  const [type, setType] = useState("All");

  const handleFilterChange = () => {
    console.log("Market:", market);
    console.log("Script:", script);
    console.log("Type:", type);
    // Call an API or update a list based on these values
  };
  return (
    <>
      <TabButtons
        tabs={LogsMenu}
        defaultTab={`${LogsMenu[0]}`}
        onTabChange={(tab) => setSelectedTab(tab)}
      />

      <div className="logs-filter-container">
        <select
          className="logs-select"
          value={market}
          onChange={(e) => {
            const value = e.target.value;
            setMarket(value);
            handleFilterChange(value, script, type);
          }}
        >
          <option value="GER">GER</option>
          <option value="USA">USA</option>
          <option value="UK">UK</option>
        </select>

        <input
          type="text"
          className="logs-input"
          placeholder="Script"
          value={script}
          onChange={(e) => {
            const value = e.target.value;
            setScript(value);
            handleFilterChange(market, value, type);
          }}
        />

        <select
          className="logs-select"
          value={type}
          onChange={(e) => {
            const value = e.target.value;
            setType(value);
            handleFilterChange(market, script, value);
          }}
        >
          <option value="All">All</option>
          <option value="Buy">Buy</option>
          <option value="Sell">Sell</option>
        </select>
      </div>
    </>
  );
};
